"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  marine: {
    vesselName: '船舶',
    statisticsName: '统计报表',
    common: {
      closeTrack: '关闭航次',
      activateTrack: '激活航次',
      diversity: '差异版本',
      invalid: '作废',
      reset: '重置',
      add: '新增',
      save: '保存',
      submit: '提交',
      operation: '操作',
      correct: '修正',
      completed: '完成',
      nextStep: '下一步',
      uploadTitle: '附件上传',
      attach: '附件',
      abstract: '摘要',
      serialnumber: '序号',
      fileName: '附件名称',
      uploadTime: '上传时间',
      uploadDepartment: '上传部门',
      uploadedBy: '上传人',
      status: '状态',
      voyageVersion: '航次版本',
      willForm: '表格必填',
      pleaseWait: '流程启动中，请等候！',
      startingSuccess: '启动成功',
      deadStart: '启动失败',
      unclosedReport: '防台风报告或者雾航报若存在开始报则必需填写结束报，请检查后再提交'
    },
    prompt: {
      confirmDel: '是否确认删除',
      pleaseInput: '请输入',
      pleaseInputNum: '请输入数字',
      pleaseInputDate: '请选择日期',
      pleaseAttachment: '请选择文件',
      pleaseFirstSave: '请先保存',
      submitAgain: '请勿重复提交',
      saveAgain: '请勿重复保存',
      versions: '最新版本跟上一版本一致，请调整后再进行修改',
      selectAuditTips: '请选择审批操作！',
      selectNodeTips: '请选择驳回节点',
      tips: '提示',
      confirmMsg: '确定',
      cancelMsg: '取消',
      confirmSub: '是否确认提交该记录',
      deleteTip: '是否确认删除该记录',
      issueVesselTip: '是否确认将该记录下发至船舶',
      deleteSuc: '删除成功',
      deleteFail: '删除失败',
      candelDel: '已取消删除',
      saveSuccess: '保存成功',
      saveFalse: '保存失败',
      refuseSuccess: '驳回成功',
      refuseFalse: '驳回失败',
      submitSuccess: '提交成功',
      submitFalse: '提交失败',
      getSuccess: '获取成功',
      getFail: '获取失败',
      fuelInformation: '请填写燃油信息',
      informationOilSampleAdd: '请添加取油样信息',
      passTips: '通过',
      refuseTips: '驳回',
      validFailTips: '操作失败，请联系管理员',
      searchFail: '搜索失败',
      infoEdit: '基本信息需要完善',
      confirmClose: '是否关闭该项目？',
      closeSuc: '关闭成功',
      closeFail: '关闭失败',
      confirmActivate: '是否激活该项目？',
      activateSuc: '激活成功',
      activateFail: '激活失败',
      cancelled: '已取消'
    }
  },
  marineChart: {
    chartSupplemenNum: '补编号',
    chartSupplemenContent: '补编内容',
    dateEdition: '补编日期',
    remark: '备注',
    effectiveSupplement: '有效补编',
    shipSupplement: '船舶补编',
    whetherBoard: '是否在船',
    isActivateTips: '是否激活该信息',
    activateTips: '提示',
    confirmTips: '确认',
    cancelTips: '取消',
    successTips: '激活成功',
    cancelledTips: '已取消',
    chartManager: '海务管理',
    breadcrumb: '航海图书监控',
    title: '船舶海图及出版物',
    companyTitle: '出版物配备标准',
    updateTitle: '海图及出版物版本更新',
    versionHistory: '最新版本更新记录',
    vesselChart: '适用船舶',
    button: {
      updateVersion: '更新版本',
      issueToVessel: '下发至船舶',
      updateSupplement: '更新补编'
    },
    query: {
      allCompany: '所有公司',
      itemName: '编号/名称',
      filterName: '过滤器',
      inputKeyWord: '请输入关键字',
      companyCode: '公司',
      vesselCode: '船舶',
      chartType: '类型'
    },
    table: {
      companyName: '公司名称',
      vesselName: '船舶名称',
      vesselCode: '船舶',
      chartType: '类型',
      chartSubType: '中/英文版',
      chartNo: '图书编号',
      chartName: '名称',
      existVersion: '在船版本',
      newVersion: '最新版本',
      existQuantity: '在船数量',
      validSupplemen: '有效补编',
      valid: '有效',
      invalid: '无效',
      chartRemark: '备注',
      inheritFlag: '继承公司模板'
    },
    form: {
      validSupplement: '有效补编',
      chartSupplemenNum: '补编号',
      chartSupplemenContent: '补编内容',
      dateEdition: '补编日期',
      remark: '备注',
      vesselCode: '船舶',
      chartType: '类型',
      chartSubType: '中/英文版',
      chartNo: '图书编号',
      chartName: '名称',
      newVersion: '最新版本',
      existVersion: '在船版本',
      existQuantity: '在船数量',
      validSupplemen: '有效补编',
      operationName: '操作人',
      lastOperationName: '最后操作人',
      operationDate: '操作日期',
      lastOperationDate: '最后操作日期',
      chartRemark: '备注',
      previousVersion: '上一版本',
      updateVersion: '更新最新版本',
      summary: '摘要',
      updater: '更新人',
      updateDate: '更新日期',
      inheritFlag: '继承公司模板',
      fixedVesselType: '适用船型',
      vesselType: '船型'
    },
    prompt: {
      vesselTips: '请选择船舶',
      chartTypeTips: '请选择类型',
      chartNameTips: '请输入名称',
      existVersionTips: '请输入在船版本',
      existQuantityTips: '请输入在船数量',
      newVersionTips: '请输入最新版本',
      selectRecordTips: '请选择一条记录',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符',
      chartNoReTips: '系统中已存在该图书编码，请修改后再进行保存',
      companyUpdateTips: '该记录继承公司模板，由公司统一更新',
      issueToVesselTips: '下发成功',
      vesselNumExistTips: '船舶已经存在不能再进行删除操作',
      fixedVesselTypesTips: '请选择船型'
    }
  },
  voyVessel: {
    index: {
      home: '海务管理',
      vessels: '航次执行',
      executing: '节点执行中',
      nodeEnd: '节点结束',
      nodeNoEdit: '节点无法编辑',
      nodeTips: '节点中的数字标识(M/N/P) M:已审批完成的数量/N:需要审批的数量/P:该节点所有记录的总数量',
      voy: '航次',
      voyExecute: '航次执行',
      cargo: '货物管理',
      bunkerOperates: '油类转移操作管理',
      bunkerOperate: '油类转移操作',
      cargoOperate: '获取装卸港口',
      chartUpdate: '海图图书预警',
      addVoyPlan: '新增航次计划',
      table: {
        port: '港口',
        trainDate: '培训日期',
        actualDate: '开始日期',
        actualEndDate: '结束日期',
        inspectionDate: '送岸日期',
        purpose: '目的',
        preparation: '准备工作',
        inPort: '在港工作',
        voyMonitor: '货物监控'
      }
    }
  },
  voyTask: {
    voyLegInfo: '航段信息',
    select: '选择',
    index: {
      titleName: '航次计划',
      revisedTitleName: '修正航次计划',
      basic: '基本信息(船长)',
      ship: '船名',
      task: '航次',
      historyVersion: '历史版本',
      startTime: '预计开始时间(LT)',
      timeZone: '时区',
      endTime: '预计结束时间(LT)',
      durationTime: '航次持续时长(天)',
      departPortCode: '始发港',
      arrivePortCode: '目的港',
      loadingPortCode: '装货港',
      dischargePortCode: '卸货港',
      middlePortCode: '中途港',
      bunkerPortCode: '加油港',
      abstract: '摘要',
      cargoInfo: '货物信息(船长)',
      portInfo: '港口信息',
      addCargo: '增加货物',
      riskAssess: '航次风险评估(船长)',
      addRisk: '增加评估',
      masterRequire: '船长指示(船长)',
      legInfo: '挂靠港(二副)',
      legInfoTips: '请二副挂靠航次计划中所有途径港，以防无法生成所需航段信息',
      addLeg: '增加航段',
      loadLine: '使用载重线(二副)',
      addLoadLine: '增加载重线',
      planSupply: '货物配载计划',
      stowagePlan: '货物配载计划(大副)',
      addStowage: '增加记载计划',
      supplyRequireDeck: '甲板部补给要求(大副)',
      food: '淡水和伙食等',
      supplyRequireEngine: '轮机部补给要求(轮机长)',
      fuel: '物料、备件及燃油等',
      revisedRemark: '修正原因'
    },
    prompt: {
      vesselTips: '请选择船舶',
      voyageNoTips: '请输入航次',
      voyagePropTips: '请输入租赁方式',
      supplyRequireDeckTips: '请输入甲板部补给要求',
      supplyRequireEngineTips: '请输入轮机部补给要求',
      departPortCodeTips: '请选择始发港',
      voyPlanTips: '请先填写航次基本信息并保存',
      voyLegSingleTips: '请选择一条航段信息，作为新增航段的出发港',
      addLegTips: '选中航段的目的港为空，请先完成该航段之后再添加新航段',
      existVoyTips: '系统中存在未执行的航次,不能再增加新航次',
      existUnEndVoyTips: '上一个航次尚未结束，请先结束上一个航次之后，再执行该操作',
      getCargoInfoTips: '货物港口来源于审批完成的航次计划，当前航次计划未审批完成，不能完成获取操作',
      revisedRemarkTips: '请填写修正原因',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符',
      dontDeleteLegATips: '该航段为始发港，不能删除',
      leaveLegTips: '该航段已经离开始发港，不能再进行删除操作，只能修改',
      voyageNodeTips: '提示：橙色表示该节点执行中，绿色表示节点结束，灰色表示当前节点不能编辑',
      voyageNodeCountTips: '每个节点中的数字标识M/N/P:其中M：已审批完成的数量，N：所有需要审批的数量，P：该节点所有记录的总数量',
      voyageNoPlanTips: '提示：系统中无航次计划，请船长制定航次计划',
      voyageNoStandardTips: '航次号用：VYY01%%标识，其中YY标识年份，01两位流水号，其中%%表示航次租赁的方式(如TC-期租、TCT-航次期租、VC-航次租船、R-修船航次)，请按照规则输入',
      voyageNoReTips: '系统中已经存在该航次号,请重新填写',
      notExsitVerTips: '系统中不存在历史版本，请先添加',
      doVoyagePlanTips: '请先制定航次计划'
    },
    cargo: {
      titleName: '货物信息',
      table: {
        cargoName: '货物名称',
        cargoTransportType: '特殊运输要求',
        cargoFlag: '属于A类货',
        cargoNum: '数量/重量',
        isolation: '隔离要求',
        cargoRemark: '备注'
      },
      form: {
        cargoName: '货物名称',
        cargoTransportType: '特殊运输要求',
        cargoFlag: '属于A类货',
        cargoFlagY: '是',
        cargoFlagN: '否',
        cargoNum: '数量/重量',
        isolation: '隔离要求',
        cargoRemark: '备注'
      },
      prompt: {
        cargoNameTips: '请选择货物',
        cargoTypeCodeTips: '请选择特殊运输要求',
        fieldLengthTips1: '长度在 1 到 20 个字符',
        fieldLengthTips2: '长度在 1 到 50 个字符',
        fieldLengthTips3: '长度在 1 到 200 个字符',
        fieldLengthTips4: '长度在 1 到 500 个字符'
      }
    },
    port: {
      table: {
        portFlag: '类型',
        portOrAnchoName: '港口/锚位',
        channelWatch: '值守频道',
        remark: '备注'
      }
    },
    leg: {
      titleName: '距离',
      table: {
        legCode: '航段号(系统自动生成)',
        legDepartPort: '出发港',
        legArrivePort: '目的港',
        legDistance: '航行距离',
        portPurpose: '目的'
      },
      form: {
        legDepartPort: '出发港',
        legArrivePort: '目的港',
        legDistance: '航行距离',
        portPurpose: '目的'
      },
      prompt: {
        arrivePortCodeTips: '请选择目的港',
        portPurposeCodeTips: '请选择目的',
        portDistanceTips: '请输入航行距离'
      }
    },
    risk: {
      titleName: '航次风险评估',
      table: {
        riskRange: '风险源',
        riskItem: '风险后果',
        riskMeasure: '采取措施'
      },
      form: {
        riskRange: '风险源',
        riskItem: '风险后果',
        riskMeasure: '采取措施'
      },
      prompt: {
        riskRangeTips: '请选择风险源',
        riskItemTips: '请输入风险后果',
        riskMeasureTips: '请输入措施',
        fieldLengthTips1: '长度在 1 到 20 个字符',
        fieldLengthTips2: '长度在 1 到 50 个字符',
        fieldLengthTips3: '长度在 1 到 200 个字符',
        fieldLengthTips4: '长度在 1 到 500 个字符'
      }
    },
    readPlan: {
      titleName: '干部船员阅知',
      table: {
        objectName: '待阅角色/人员',
        readName: '已阅人员',
        readTime: '已阅日期'
      }
    },
    stowageplan: {
      titleName: '货物配载计划',
      table: {
        cargoName: '货物名称',
        portCode: '装货港',
        seaDensity: '海水密度g/cm3',
        arriveDraft: '抵港水尺(m)',
        departDraft: '开航水尺(m)',
        no1: 'No.1(MT)',
        no2: 'No.2(MT)',
        no3: 'No.3(MT)',
        no4: 'No.4(MT)',
        no5: 'No.5(MT)',
        no6: 'No.6(MT)',
        no7: 'No.7(MT)',
        no8: 'No.8(MT)',
        no9: 'No.9(MT)',
        deck: 'Deck(MT)',
        totalNum: '总重量(MT)'
      },
      form: {
        portCode: '装货港',
        cargoName: '货物名称',
        seaDensity: '海水密度g/cm3',
        arriveDraft: '抵港水尺',
        departDraft: '开航水尺',
        Front: '/dF',
        in: '/dM',
        after: '/dA',
        no1: 'No.1(MT)',
        no2: 'No.2(MT)',
        no3: 'No.3(MT)',
        no4: 'No.4(MT)',
        no5: 'No.5(MT)',
        no6: 'No.6(MT)',
        no7: 'No.7(MT)',
        no8: 'No.8(MT)',
        no9: 'No.9(MT)',
        deck: 'Deck(MT)',
        totalNum: '总重量(MT)',
        planTotalNum: '计划货量(MT)'
      },
      prompt: {
        cargoNameTips: '请选择货物',
        portCodeTips: '请选择港口',
        fieldLengthTips1: '长度在 1 到 20 个字符',
        fieldLengthTips2: '长度在 1 到 50 个字符',
        fieldLengthTips3: '长度在 1 到 200 个字符',
        fieldLengthTips4: '长度在 1 到 500 个字符'
      }
    },
    loadline: {
      titleName: '使用载重线',
      table: {
        startPosition: '出发位置',
        endPosition: '到达位置',
        usedLoadline: '使用载重线'
      },
      form: {
        startPosition: '开始位置',
        endPosition: '到达位置',
        usedLoadline: '使用载重线'
      },
      prompt: {
        startPositionTips: '请输入开始位置',
        endPositionTips: '请输入到达位置',
        usedLoadlineTips: '请选择使用载重线',
        fieldLengthTips1: '长度在 1 到 20 个字符',
        fieldLengthTips2: '长度在 1 到 50 个字符',
        fieldLengthTips3: '长度在 1 到 200 个字符',
        fieldLengthTips4: '长度在 1 到 500 个字符'
      }
    },
    VoyageTaskTracking: {
      previousVo: '上一航次',
      nextVo: '下一航次',
      title: '航次历史查询',
      qualityRecordName: '体系表格名称',
      qualityRecordCount: '体系表格数量',
      companyName: '公司',
      vesselName: '船舶',
      voyageNo: '航次',
      departPort: '出发港',
      arrivePort: '目的港',
      startTime: '预计开始时间',
      endTime: '预计结束时间',
      voyageDay: '航行天数',
      status: '状态',
      operate: '操作'
    }
  },
  voyStart: {
    titleName: '开航前检查'
  },
  voyPlan: {
    titleName: '航行计划',
    shipName: '船名',
    voyTaskName: '航次',
    departPortCode: '出发港',
    arrivePortCode: '目的港'
  },
  voyIn: {
    titleName: '航行中检查'
  },
  voyEnd: {
    titleName: '航次总结',
    uploadTips1: '请上传甲板部日志',
    uploadTips2: '请上传轮机日志'
  },
  voyAfter: {
    titleName: '抵港后检查'
  },
  editGoods: {
    mainTitleName: '海务管理',
    titleName: '货物管理',
    cargoStep1: '准备工作(装/卸货前)',
    cargoStep2: '在港作业(装/卸货过程)',
    cargoStep3: '货物监控((装/卸货后)',
    basicInfo: '基本信息',
    shipName: '船名',
    voyTaskName: '航次',
    cargoInfo: '货物信息',
    port: '港口',
    aim: '到港目的',
    goodsPhotos: '货舱状况照片',
    prompt: {
      confirmCompleted: '请确认该港口所有资料都填写完整？提交后，本节点的信息将不允许再修改，如果要修改，请通知船长重新激活流程状态。',
      selectCargoInfo: '请选择该港口装卸货的货物',
      selectSaveCargoInfo: '请选择该港口装卸货的货物,并进行保存操作！',
      notSaveCargoInfo: '注：请选择该港口装卸货的货物并进行保存，保存完成后将会生成需要填写的体系文件'
    }
  },
  bunkerTransfer: {
    mainTitleName: '海务管理',
    titleName: '油类转移操作',
    bunkerStep1: '油类转移-计划',
    bunkerStep2: '油类转移-培训',
    bunkerStep3: '油类转移-风险评估',
    bunkerStep4: '油类转移-实际操作',
    bunkerStep5: '油类转移-油样送岸',
    bunkerStep6: '油类转移-化验报告',
    basicInfo: '基本信息',
    supplierInfo: '供应商信息',
    supplierName: '供应商',
    oilName: '油品名称',
    transferCount: '转移量（MT）',
    remark: '备注',
    vesselName: '船名',
    voyTaskName: '航次',
    port: '港口',
    country: '国家',
    planNo: '计划编码',
    planStartDate: '计划开始日期(LT)',
    planEndDate: '计划结束日期(LT)',
    trainDate: '计划培训日期(LT)',
    actualTrainDate: '实际培训日期(LT)',
    timeZone: '时区',
    planNoMessage: '请输入计划编码',
    portMessage: '请选择港口',
    timeZoneMessage: '请选择时区',
    planStartDateMessage: '请选择计划开始日期',
    planEndDateMessage: '请选择计划结束日期',
    trainDateMessage: '请选择培训日期',
    actualTrainDateMessage: '请选择实际培训日期',
    trainTitle: '培训',
    trainExplain: '在计划加油前的48小时内，轮机长应对所有参加加油人员有关其在本程序中的职责及作业计划进行培训。参加培训的人员的名字、职务以及具体的时间等应在轮机日志及甲板航海日志中详加记录。',
    expectRiskDate: '预计风险评估日期(LT)',
    expectRiskDateMessage: '请选择预计风险评估日期',
    riskAssess: '风险评估',
    actualStartDate: '实际开始时间(LT)',
    actualStartDateMessage: '请选择实际开始时间',
    actualEndDate: '实际结束时间(LT)',
    actualEndDateMessage: '请选择实际结束时间',
    OilSampleDeliveryDate: '油样送岸时间(LT)',
    OilSampleDeliveryDateMessage: '请选择油样送岸时间',
    firstBunkerMeeting: '加油前碰头会',
    firstBunkerMeetingExplain: '在加油作业开始之前，所有参加加油人员，包括岸上或加油船上的人员应举行一次碰头会议。如果船长认为岸上或加油船上人员上船不安全可以不参加。参加人员重点讨论如何通知加油船或岸上加油站的人员关于转换油舱或满舱而减速等，还应确定应急停泵程序及联系办法。上述各项内容应在航海日志中予以记录。',
    firstBunkerMeetingExplainTwo: '每次加完燃油，必须及时寄送油样给指定的化验机构进行化验。在没有收到化验报告之前，不得使用该燃油。收到报告之后，需要遵循报告里面关于燃油的储存、驳运及分油等建议。',
    firstBunkerMeetingExplainThree: '如果船上没能及时收到油品的化验报告，而不得不使用未知品质的燃油，必须提前通知公司机务部，并按照稳定性、兼容性、残留催化剂等方面进行风险评估、做好预防措施。',
    testReportTitle: '油样化验报告',
    supplierMessage: '请至少添加一个供应商',
    oilInfoSourceNullTips: '供应商列表供应商/油品名称/(转移量>0)需要填写完整',
    prompt: {
      confirmSub: '确定要完成油类转移操作',
      completedSuc: '完成',
      completedFail: '操作失败'
    },
    testReport: {
      reportTitle: '化验报告',
      testOrg: '化验机构',
      testOrgInput: '请输入化验机构',
      sampleNo: '铅封号',
      sampleNoSelect: '请选择铅封号',
      supplierName: '供应商',
      bunkerCode: '油品名称',
      shoreRemark: '岸基总管意见',
      shoreRemarkInput: '请输入岸基总管意见',
      vesselRemark: '船端反馈',
      vesselRemarkInput: '请输入船端反馈',
      status: '状态'
    },
    bunkerSample: {
      takeBunkerSample: '取油样',
      bunkerVendor: '供应商',
      sampleNo: '铅封号',
      samplePurposeCode: '用途',
      samplePurposeCodeSelect: '请选择用途',
      sampleRemark: '备注',
      supplierName: '请选择供应商',
      sampleNoInput: '请输入铅封号'
    },
    bunkerBank: {
      bankerRecord: '油舱记录',
      index: '序号',
      tankNo: '油舱',
      tankNoSelect: '请选择油舱',
      bunkerType: '油品名称',
      bunkerTypeSelect: '请选择油品名称',
      beforeQuantity: '转移前存量(MT)',
      beforeQuantityInput: '请输入转移前存量',
      beforeSulfur: '转移前含硫量(%)',
      beforeSulfurInput: '请输入转移前含硫量',
      afterQuantity: '转移后存量(MT)',
      afterQuantityInput: '请输入转移后存量',
      afterSulfur: '转移后含硫量(%)',
      afterSulfurInput: '请输入转移后含硫量',
      remark: '备注'
    }
  },
  editPilot: {
    titleName: '引航员信息',
    basicInfo: '基本信息',
    pilotName: '引航员姓名',
    portFlag: '类型',
    portName: '港口',
    timeZone: '时区',
    onDate: '上船日期(LT)',
    leaveDate: '下船日期(LT)',
    masterName: '船长',
    onPosition: '登轮点',
    leavePosition: '离船点',
    serviceQuality: '服务质量',
    exchangeTable: '船长和引水员资料互换表',
    prompt: {
      pilotNameTips: '请输入引航员姓名',
      onDateTips: '请选择上船日期(LT)',
      leaveDateTips: '请选择下船日期(LT)',
      onPositionTips: '请输入登轮点',
      leavePositionTips: '请输入离船点',
      serviceQualityTips: '请输入服务质量',
      timeZoneTips: '请输入时区',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  MarineNarrow: {
    titleName: '狭水道航行',
    inspection: '狭水道信息',
    shipName: '船名',
    voyTaskName: '航次',
    seaArea: '海域',
    SpecialpointName: '狭水道名称',
    remarks: '备注',
    checkDate: '检查日期(LT)',
    checkTimeZone: '时区',
    startDate: '开始日期',
    startTimeZone: '开始时区',
    endDate: '结束日期',
    endTimeZone: '结束时区',
    prompt: {
      specialCodeTips: '请选择狭水道名称',
      checkDateTips: '请输入检查日期',
      checkTimeZoneTips: '请选择时区',
      startDateTips: '请选择开始日期',
      startTimeZoneTips: '请选择开始时区',
      endDateTips: '请选择结束日期',
      endTimeZoneTips: '请选择结束时区',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  MarineFrog: {
    frogReptTitle: '船舶雾航报告表',
    frogCheckTitle: '船舶雾航自检表',
    sysNo: '雾航编码(系统生成)',
    reportType: '类型',
    shipName: '船名',
    shipCode: '航次',
    dataTime: '报告日期(LT)',
    code: '报告编号',
    visibility: '能见度(级)',
    seaArea: '海域',
    course: '航向(°)',
    Speed: '航速(Kt)',
    shipPosition: '船位(锚位)',
    lastShipPosition: '船位(结束时)',
    driver: '值班驾驶员',
    seaman: '值班水手',
    windDirection: '风向',
    windPower: '风力(BF)',
    WaveHeight: '浪高(m)',
    Yonggao: '涌高(m)',
    weatherCondition: '天气状况',
    DryBall: '干球温度(℃)',
    bulb: '湿球温度(℃)',
    density: '通航密度',
    Theseamusttake: '3-5海里须采取的雾航安全措施',
    outlook: '加强瞭望',
    SafeSpeed: '安全航速',
    radar: '使用雷达连续观测标绘',
    drives: '开启驾驶台门窗',
    VHF: '监听VHF',
    shipQuiet: '保持全船肃静',
    fogSignal: '鸣放雾号',
    navigation: '开启航行灯',
    captain: '报告船长',
    byHand: '手操舵',
    Inform: '通知机舱',
    ConsiderIncreasing: '3海里以下应考虑增加以下的雾航安全措施',
    TwoRadars: '使用两部雷达连续观测标绘',
    warningVia: '通过VHF发布雾航警告',
    driving: '船长在驾驶台指挥',
    vehicle: '备车航行',
    theHead: '派人了头',
    andDetention: '停车滞航',
    anchor: '准备抛锚',
    NavigationEquipment: '航海设备、仪器、通讯设备',
    Normal: '正常',
    Deficiency: '有缺陷',
    security: '为确保船舶雾航安全，当视线恶劣、渔船密集、避让困难、航道复杂及船长对航行安全无把握时，在条件许可的情况下，船长有权择地锚泊或滞航，切勿盲目航行。',
    remarks: '备注',
    checkDate: '检查日期(LT)',
    checkTimeZone: '时区',
    startDate: '开始日期',
    startTimeZone: '开始时区',
    endDate: '结束日期',
    endTimeZone: '结束时区',
    minVisibility: '能见度(级)(最小)',
    totalTime: '雾航总时间(小时)',
    takeMeasures: '采取措施',
    prompt: {
      sysReportNoTips: '请选择雾航编码',
      reportDateTips: '请选择报告日期',
      reportNoTips: '请输入报告编号',
      frogVisibilityTips: '请输入能见度',
      seaAreaCodeTips: '请输入海域',
      sailingCourseTips: '请选择航向',
      sailingSpeedTips: '请输入航速',
      vesselPositionTips: '请输入船位',
      checkDateTips: '请选择检查日期(LT)',
      checkTimeZoneTips: '请输入时区',
      startDateTips: '请选择开始日期',
      startTimeZoneTips: '请选择开始时区',
      endDateTips: '请选择结束日期',
      endTimeZoneTips: '请选择结束时区',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  MarineSummary: {
    infoSummary: '航次总结',
    Voyagestarttime: '实际开始时间',
    Voyageendtime: '实际结束时间',
    Duration: '时长',
    vesselType: '船型',
    status: '状态',
    Addedby: '添加人',
    AddDate: '添加日期',
    adds: '添加',
    information: '航次基本信息(来源航次计划，不能编辑)',
    route: '航线(来源于航次计划)',
    objective: '挂靠目的 (装货、卸货、加油、其他)',
    Summary: '航线总结',
    conduction: '租家是否提供气导',
    Yes: '是',
    No: '否',
    Loadline: '载重线(来源航次计划，不能编辑)',
    event: '事件',
    describe: '描述',
    position: '位置（或范围）',
    measures: '采取的措施及结果',
    Summaryoftheports: '港口总结',
    Port: '港口/锚地',
    remark: '备注',
    remarkMax: '备注',
    portName: '港口/锚地名称',
    portNameSelect: '请选择港口',
    anchorName: '锚地',
    anchorNameInput: '请输入锚地',
    channel: 'VHF守值频道',
    channelInput: '请输入VHF守值频道',
    pilot: '引航员(来源于航行中填写的引航员信息,不可编辑)',
    name: '姓名',
    boardFront: '登轮点',
    Lat: 'Lat',
    Long: 'Long',
    service: '服务质量',
    describes: '其他描述',
    SegmentSituation: '航道情况',
    length: '长度、宽度及维护水深',
    Shallow: '浅点位置及水深',
    tide: '潮汐与水流情况',
    otherTide: '其他说明',
    Berthing: '靠、离/锚泊情况',
    Numberoftugs: '拖轮数量及马力',
    BerthingPosition: '靠泊位置及水深',
    Cargo: '货物操作',
    Useofcargocrane: '货吊使用',
    Cargohandlingteam: '装卸货工班情况及速率',
    Stevedoreswork: '装卸工人工作质量',
    Assessment: '公估情况、水密度',
    Entry: '进出港手续',
    equirements: '抵港报要求',
    ready: '文件准备',
    Otherrequiremen: '其他要求',
    situation: '安保状况',
    Smuggling: '偷渡、港口治安等',
    Security: '保安等级',
    Voyagesummaryreport: '航次总结报告',
    cargoInfo: '货物信息(来源航次计划，不能编辑)',
    badWeather: '恶劣天气、海况',
    seaSafety: '海上保安',
    denseTrafficZone: '航行密集区',
    specialArea: '特殊航区(点)',
    others: '其他',
    voyPortInfo: '航次港口信息',
    port: '港口',
    anchor: '锚地',
    prompt: {
      startTimeTips: '请输入实际开始日期',
      endTimeTips: '请输入实际结束日期',
      timeZoneTips: '请选择时区',
      pleaseFirstSave: '请先保存',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  uck: {
    titleName: '富余水深计算',
    parameterinformation: '参数信息',
    essentialinformation: '基本信息',
    position: '地名/位置',
    Speed: '航速(Kt)',
    waterArea: '水域',
    distance: '候潮的距离长度(NM)',
    weaveHeight: '浪高(m)',
    Draft: '吃水',
    Front: '艉',
    in: '舯',
    after: '艏',
    visibility: '区域',
    seaState: '富余水深名称',
    heavyOil: '抵达时间(LT)',
    arriveDate: '实际抵达时间',
    Standard: '标准海水密度下的船舶排水量(注:根据船舶吃水，从稳性计算书查得)',
    appoint: '指定水密度',
    centimeter: '当前吃水状态下船舶每厘米吃水吨数(注:根据船舶吃水，从稳性计算书查得)',
    Variation: '水密度变化引起的吃水变化量(注:(标准海水密度下的船舶排水量*(1.025-指定水密度)/1.025)/当前吃水状态下船舶每厘米吃水吨数/100)',
    recommend: '最大通过速度(节)',
    Shipwidth: '船舶宽度',
    angle: '横倾角度',
    coefficient: '方形系数(注:根据船舶吃水，从稳性计算书查得)',
    Subsidence: '下沉量',
    Shallowwaters: '浅水水域',
    Deepwater: '深水水域',
    Shallowest: '航道或泊位最浅点水深',
    ENC: '海图可信度修正',
    weather: '天气影响水深变化量(注:天气影响水深变化量按30%波浪高度计算)',
    Surpluswater: '要求的净富余水深(注:根据体系文件要求)',
    result: '结果',
    specified: '指定水密度下的吃水(注:吃水+水密度变化引起的吃水变化量)',
    Static: '经修正的船舶静态吃水(注:指定水密度下的吃水)',
    Correction: '横倾改正(注:经修正的船舶静态吃水*COS(横倾角度/180)+1/2*船舶宽度(横倾角度 *3.1415926/180)-经修正的船舶静态吃水)',
    Effectve: '实际吃水(注:经修正的船舶静态吃水+下沉量+横倾改正)',
    DYnamic: '动态水深(注:动态水深为航道或泊位最浅点水深，减去海图可信度修正、天气影响水深变化量及要求的净富余水深)',
    Requiredheight: '要求的潮高(注:动态水深-实际吃水)',
    requiredHeightTips: '若计算出来“要求的潮高”小于或等于“0”，则无须继续计算潮汐',
    TidalTnformation: '潮汐信息',
    heightTide: '要求的潮高开始于',
    end: '要求的潮高结束于',
    Duration: '要求的潮汐时长',
    Safe: '安全通过浅滩所需时长',
    add: '增加',
    tideTable: '潮汐表',
    tide: '潮汐',
    Time: '时间',
    Height: '潮高',
    Selectdate: '选择日期',
    ukcName: 'UKC名称',
    seaAreaCode: '海域',
    ukcStandard: 'UKC标准',
    vesselPosition: '位置(经纬度)',
    ukcFlag: '类型',
    calResult: '计算结果',
    fitFlag: '是否符合要求',
    ukcStatus: '状态',
    waterFlag: '水域',
    noPassSaveFlag: '不能安全通过',
    passSafeFlag: '安全通过',
    timeZone: '时区',
    prompt: {
      placeNameTips: '请输入地名/位置',
      seaAreaCodeTips: '请输入海域',
      arriveDateTips: '请选择到达时间',
      waveHeightTips: '请输入浪高',
      sqFlagTips: '请选择水域',
      timeZoneTips: '请输入时区',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  MarineTyphoon: {
    titleName: '防抗台风报告',
    typhoonInfo: '大风浪天信息',
    typhoonSysNo: '编码',
    typhoonSysType: '类型',
    typhoonNo: '台风编号',
    typhoonName: '台风名称',
    seaAreaCode: '海域',
    shiplongitude: '船位锚位(经度)',
    shiplatitude: '船位锚位(纬度)',
    Selectdate: '选择日期',
    shipName: '船名',
    shipCode: '航次',
    dataTime: '报告时间(LT)',
    timeZone: '时区',
    code: '报告编号',
    departure: '始发港',
    destination: '目的港',
    Shipposition: '船位(锚位)',
    endShipPosition: '结束时船位(锚位)',
    longitude: '经度',
    latitude: '纬度',
    goods: '货物',
    draft: '吃水(m)',
    Front: '前',
    in: '中',
    after: '后',
    weather: '天气',
    windDirection: '风向',
    windPower: '风力(BF)',
    course: '航向(°)',
    pressure: '气压(hpa)',
    visibility: '能见度(级)',
    seaState: '海况(级)',
    Speed: '航速(Kt)',
    temperature: '气温(℃)',
    heavyOil: '重油FO(MT)',
    lightOil: '轻油DO(MT)',
    freshwater: '淡水FW(MT)',
    BallastWater: '压载水BW(MT)',
    engineSpeed: '主机转速RPM',
    position: '台风位置',
    CentralPressure: '中心气压(hpa)',
    MovingDirection: '移动方向',
    movingSpeed: '移动速度(Kt)',
    ShipCenter: '船舶距中心(NM)',
    cause: '对船舶造成',
    affectingships: '影响船舶的天气系统',
    Monsoon: '季风',
    Sources: '资料来源',
    Fax: '传真天气图',
    NAVTEX: 'NAVTEX',
    C: 'C站',
    AC: '气导',
    Others: '其它',
    informationTime: '最近气象资料时间',
    Antagonizing: '已采取的防抗措施',
    conference: '召开防台工作会议',
    Yes: '有',
    No: '无',
    equipment: '检查防台设备',
    Normal: '正常',
    Deficiency: '有缺陷',
    info: '主机、辅机、舵机、锚机、锅炉情况',
    sail: '航行中',
    SD: '减速',
    SA: '加速',
    Heaveto: '滞航',
    Change: '改向',
    measures: '采取的措施已报告气导、租家、公司',
    shelter: '锚地遮蔽情况',
    Good: '良好',
    Poor: '无遮蔽',
    texture: '底质',
    Goods: '好',
    Moderate: '一般',
    Poors: '差',
    anchor: '抛锚方法',
    Onepoint: '一点锚',
    OpenMooring: '八字锚',
    SingleAnchoring: '单锚(左锚或右锚)',
    PortAnchor: '左锚',
    Starboard: '右锚',
    Kts: '节',
    objectMark: '定位物标',
    Prominent: '明显',
    nearestDistance: '最近距离',
    NM: '海里NM',
    flow: '流',
    Fast: '急',
    Speedp: '流速',
    urgent: '系泊中',
    Authority: '与港口当局联系',
    SBE: '备车',
    mooringLines: '加缆',
    Anchorage: '移至锚地',
    Assistance: '拖轮协助',
    recommend: '气导推荐方案',
    situation: '船舶和货物情况',
    // checkTitleName: '船舶防台设备检查报告',
    checkTitleName: '大风浪天检查表',
    NA: 'N/A',
    checkDate: '检查日期(LT)',
    checkTimeZone: '时区',
    losedTime: '损失的时间(小时)',
    deviateMile: '绕航里程(海里)',
    consumedOil: '燃油额外消耗(吨)',
    sufferLose: '遭受损失',
    personInjured: '人员伤亡(人)',
    personName: '姓名',
    injuredRemark: '伤亡描述',
    polluteSituation: '污染情况',
    deviceDamage: '设备损坏(名称)',
    otherDamage: '其它(具体指明)',
    startDate: '开始日期',
    startTimeZone: '开始时区',
    endDate: '结束日期',
    endTimeZone: '结束时区',
    totalTime: '通过台风总时间(小时)',
    takeMeasures: '采取措施',
    deviateMeasure: '绕航措施',
    stopMeasure: '漂/滞航措施',
    cargoCondition: '装、卸情况',
    vesselStatus: '动态',
    ladenType: '载货情况',
    centralWindSpeed: '中心附近最大风力(m/s)',
    relativePosition: '处于台风的象限',
    prompt: {
      sysReportNoTips: '请选择编码',
      reportNoInputTips: '请输入编号01、02、03......',
      courseInputTips: '请输入航向000到359整数',
      seaAreaCodeTips: '请输入海域',
      specialCodeTips: '请输入台风编号或者名称',
      reportDateTips: '请选择报告日期',
      checkDateTips: '检查日期(LT)',
      timeZoneTips: '请输入时区',
      reportNoTips: '请输入报告编码',
      vesselPositionTips: '请输入船舶位置',
      endVesselPositionTips: '请输入结束船舶位置/锚位',
      sailingCourseTips: '请选择航向',
      sailingSpeedTips: '请选择航速',
      windCourseTips: '请选择风向',
      windSpeedTips: '请选择风速',
      vesselStatusTips: '请输入动态',
      frogVisibilityTips: '请输入能见度',
      deficiencyTips: '若存在缺陷，请输入',
      othersTips: '补充说明',
      deviateMeasureTips: '拟过台风尾或抢台风头；保持与台风中心的最小距离。如：拟过台风尾与台风中心最小距离保持300海里以上',
      stopMeasureTips: '应注明采取漂航或滞航方式，注明经纬度，保持离台风中心最近距离。如：漂航于2538N/12035E，与台风中心最小距离保持300海里以上。',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符',
      inputPersonInjuryTips: '请填写人员伤亡信息',
      startDateTips: '请选择开始日期',
      startTimeZoneTips: '请选择开始时区',
      endDateTips: '请选择结束日期',
      endTimeZoneTips: '请选择结束时区'
    }
  },
  Voyagetracking: {
    mngTitle: '海务管理',
    pageTitle: '新航次或者港口评审',
    companyCode: '公司',
    vesselCode: '船舶',
    voyageNo: '航次',
    Port: '港口',
    Assessor: '评估人',
    Evaluationdate: '评估日期',
    Newrouteassessment: '新航线评估',
    Newportassessment: '新港口评估',
    conclusion: '结论',
    state: '状态',
    Expectedarrivaldate: '预计到达日期',
    since: '自',
    to: '至',
    operationName: '创建人',
    operationDate: '创建日期',
    yesNo: '是否被引用',
    associatedVoyage: '关联航次',
    prompt: {
      vesselTips: '请选择船舶',
      voyageNoTips: '请输入航次',
      portTips: '请选择港口',
      assessPersonTips: '请输入评估人',
      assessDateTips: '请选择评估日期',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符',
      fieldLengthTips5: '长度在 1 到 2000 个字符'
    }
  },
  MarinePirate: {
    titleName: '通过海盗区',
    pirateName: '海盗区',
    securityName: '武装安保',
    navalName: '海军护航',
    seaArea: '海域',
    reportDate: '报告日期',
    timeZone: '时区',
    startDate: '开始日期',
    startTimeZone: '开始时区',
    endDate: '结束日期',
    endTimeZone: '结束时区',
    attackPirate: '是否收到海盗袭扰',
    securityFlag: '是否雇佣武装安保',
    onDate: '上船日期',
    onTimeZone: '上船时区',
    leaveDate: '下船日期',
    leaveTimeZone: '下船时区',
    onPosition: '上船位置',
    leavePosition: '下船位置',
    navalFlag: '是否安排海军护航',
    navalStartDate: '护航开始日期',
    navalStartTimeZone: '时区',
    navalEndDate: '护航结束日期',
    navalEndTimeZone: '时区',
    navalStartPosition: '护航开始位置',
    navalEndPosition: '护航结束位置',
    pirateRemark: '备注',
    Yes: '是',
    No: '否',
    prompt: {
      seaAreaTips: '请选择海域',
      reportDateTips: '请输入报告日期',
      timeZoneTips: '请选择报告时区',
      startDateTips: '请选择开始日期',
      startTimeZoneTips: '请选择开始时区',
      endDateTips: '请选择结束日期',
      endTimeZoneTips: '请选择结束时区',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  MarineGoodHope: {
    titleName: '通过好望角水域',
    ladenFlag: '装载',
    isLaden: '是否重压载',
    draft: '吃水',
    draftF: 'dF',
    draftA: 'dA',
    draftTableF: '吃水(dF)',
    draftTableA: '吃水(dA)',
    reportDate: '报告日期(LT)',
    timeZone: '时区',
    badWeatherFlag: '是否遭遇恶劣海况',
    happenDate: '发生日期',
    windPower: '风力(级)',
    waveHeight: '浪高(级)',
    swellHeight: '涌浪(级)',
    takeMeasure: '采取措施',
    remark: '备注',
    Yes: '是',
    No: '否',
    prompt: {
      ladenFlagTips: '装载',
      draftTips: '请输入吃水',
      reportDateTips: '请输入报告日期(LT)',
      timeZoneTips: '请选择时区',
      fieldLengthTips1: '长度在 1 到 20 个字符',
      fieldLengthTips2: '长度在 1 到 50 个字符',
      fieldLengthTips3: '长度在 1 到 200 个字符',
      fieldLengthTips4: '长度在 1 到 500 个字符'
    }
  },
  highRisk: {
    index: {
      home: '海务管理',
      title: '高风险国家/港口',
      queryName: '过滤器',
      querycountry: '国家',
      queryPort: '港口',
      disabledBtn: '禁用',
      disableMsg: '是否要禁用该记录',
      disableSuccessMsg: '已成功禁用该记录',
      cancelDisableMsg: '已取消禁用该记录',
      table: {
        areaType: '区域类型',
        country: '国家',
        port: '港口',
        riskDescribe: '风险描述',
        riskMeasure: '防范措施与建议',
        effective: '生效日期',
        dateCreated: '创建日期',
        dateUpdated: '更新日期',
        expity: '失效日期',
        areaTypeC: '国家',
        areaTypeP: '港口'
      }
    },
    editHighRisk: {
      title: '高风险国家/港口',
      baseTitle: '基本信息',
      form: {
        fileName: '附件上传',
        voyageNo: '航次号',
        shipName: '船舶',
        reportTitle: '船舶航次港口水深资料报告',
        riskType: '风险类型',
        baseTitle: '基本信息',
        areaType: '区域类型',
        country: '国家',
        port: '港口',
        countryPort: '国家/港口',
        riskDescribe: '风险描述',
        riskMeasure: '防范措施与建议',
        effective: '生效日期',
        expity: '失效日期',
        validFlag: '状态'
      },
      selectMessage: {
        country: '国家',
        port: '港口'
      },
      formRules: {
        areaType: '区域类型不能为空',
        countryNull: '区域类型选择为国家时，国家不能为空',
        country: '已存在该国家',
        countryPort: '国家/港口不能为空',
        portNull: '区域类型选择为港口时，港口不能为空',
        port: '已存在该港口',
        riskDescribe: '风险描述不能为空',
        riskMeasure: '防范措施与建议不能为空',
        effective: '生效日期不能为空',
        riskTypeTips: '风险类型不能为空',
        saveTips: '国家或港口已存在'
      }
    }
  },
  voyPortStatistics: {
    home: '海务管理',
    title: '抵港统计',
    filterName: '过滤器',
    queryVessel: '船舶',
    queryPort: '港口',
    queryDate: '起止日期',
    exportBtn: '导出',
    noData: '暂无数据',
    table: {
      vesselName: '船舶',
      voyageNo: '航次号',
      port: '港口',
      country: '国家',
      arrivePortDate: '到港日期',
      arriveTimeZone: '到港时区',
      leavePortDate: '离港日期',
      leavePortTime: '离港时区',
      arrivePortPurpose: '到港目的',
      remark: '备注'
    }
  },
  voyPirateStatistics: {
    home: '海务管理',
    title: '通过海盗区统计',
    filterName: '过滤器',
    queryVessel: '船舶',
    queryArea: '海域',
    queryDate: '起止日期',
    exportDetailBtn: '导出详情',
    exportShipBtn: '导出航筹办',
    table: {
      vesselName: '船名',
      pirateCode: '海域',
      startDate: '开始日期',
      endDate: '结束日期',
      security: '武装保安',
      naval: '海军护航',
      securityFlag: '是否雇佣',
      onPosition: '上船位置',
      onDate: '上船时间',
      leavePosition: '下船位置',
      leaveDate: '下船时间',
      navalFlag: '是否加入',
      navalStartPosition: '护航开始位置',
      navalStartDate: '护航开始时间',
      navalEndPosition: '护航结束位置',
      navalEndDate: '护航结束时间'
    }
  },
  voyGoodHopeStatistics: {
    home: '海务管理',
    title: '通过好望角水域统计',
    filterName: '过滤器',
    queryVessel: '船舶',
    queryDate: '起止日期',
    exportBtn: '导出',
    table: {
      vesselName: '船名',
      voyageNumber: '航次',
      reportDate: '报告日期（LT）',
      load: '装载',
      df: '吃水（dF）',
      da: '吃水（dA）',
      badWeatherFlag: '是否碰到恶劣天气',
      windSpeed: '风力（级）',
      waveLevel: '浪高（m）',
      swellLevel: '涌浪（m）',
      takeMeasure: '采取措施',
      badWeatherFlagYes: '是',
      badWeatherFlagNo: '否'
    }
  },
  voyNarrowStatistics: {
    home: '海务管理',
    title: '通过狭水道统计',
    filterName: '过滤器',
    queryVessel: '船舶',
    queryNarrow: '狭水道',
    queryDate: '起止日期',
    exportBtn: '导出',
    table: {
      vesselName: '船名',
      voyageNumber: '航次',
      df: '吃水（dF）',
      da: '吃水（dA）',
      narrowName: '狭水道名称',
      startDate: '开始日期',
      startTimeZone: '开始时区',
      endDate: '结束日期',
      endTimeZone: '结束时区'
    }
  },
  voyFrogStatistics: {
    home: '海务管理',
    title: '通过雾航统计',
    filterName: '过滤器',
    queryVessel: '船舶',
    queryDate: '起止日期',
    exportBtn: '导出',
    table: {
      vesselName: '船名',
      voyageNumber: '航次',
      ladenType: '装载情况',
      seaAreaCode: '海域',
      visibility: '能见度',
      fogNavalStartDate: '雾航开始日期',
      fogNavalEndDate: '雾航结束日期',
      startTimeZone: '开始时区',
      endTimeZone: '结束时区',
      fogNavalAllTime: '雾航总时间',
      takeMeasure: '采取措施',
      remark: '备注'
    }
  },
  voyTyphoonTrackStatistics: {
    home: '海务管理',
    title: '受台风影响船舶跟踪表（航筹办）',
    filterName: '过滤器',
    queryVessel: '船舶',
    tackValue: '台风编号/名称',
    queryDate: '起止日期',
    table: {
      vesselName: '船名',
      voyageNumber: '航次',
      specialCode: '台风编码',
      specialName: '台风名称',
      vesselPosition: '当前船位',
      vesselStatus: '动态',
      sailingCourse: '航向',
      sailingSpeed: '航速',
      departPortName: '出发港',
      arrivePortName: '目的港',
      ladenType: '载货',
      typhoonPosition: '装、卸情况',
      measuresInfo: '防抗台风计划或已采取的防御措施',
      deviatedMeasure: '绕航措施',
      stopMeasure: '漂/滞航措施',
      anchorWay: '锚位/抛锚方式（单锚、一点锚、八字锚）/链长',
      anchorType: '锚位/抛锚方式',
      leftChainLength: '左链长',
      rightChainLength: '右链长',
      deviceStatus: '车、舵、电机、锅炉、锚设备工况',
      otherMeasure: '其它防台措施',
      remark: '备注'
    }
  },
  voyTyphoonSumStatistics: {
    home: '海务管理',
    title: '台风影响船舶生产情况统计表（航筹办）',
    filterName: '过滤器',
    queryVessel: '船舶',
    tackValue: '台风编号/名称',
    queryDate: '起止日期',
    table: {
      vesselName: '船名',
      voyageNumber: '航次',
      trackCode: '台风编码',
      trackName: '台风名称',
      lossTime: '船舶锚泊、滞航或绕航或单位停产损失的时间（小时）',
      detourMileage: '船舶绕航里程（海里）',
      additionalLoss: '船舶采取避台措施产生的燃油额外消耗（吨）',
      lossInfo: '遭受损失',
      casualties: '人员伤亡（人）',
      pollutionInfo: '污染情况',
      equipmentInfo: '设备损坏（名称）',
      otherInfo: '其他（具体指明）'
    }
  },
  voyTyphoonStatistics: {
    home: '海务管理',
    title: '台风跟踪记录表(安监部)',
    filterName: '过滤器',
    queryVessel: '船舶',
    tackValue: '台风编号/名称',
    queryDate: '起止日期',
    table: {
      vesselName: '船名',
      voyageNumber: '航次',
      trackCode: '台风编码',
      trackName: '台风名称',
      reportDate: '汇报日期',
      anchorPosition: '船位（锚位）',
      trackPosition: '台风位置',
      pressure: '气压',
      maxWind: '中心附件最大风力（m/s）',
      moveDirection: '移动方向',
      moveSpeed: '移动速度',
      distance: '与台风中心相距（nm）',
      quadrant: '处于台风的象限',
      currentWeather: '现场天气',
      currentMeasures: '所采取的措施',
      detourMileage: '绕航里程',
      detourOil: '绕航油耗',
      timeLoss: '时间损耗'
    }
  },
  oilTransfer: {
    title: '油类转移查询',
    portCode: '港口',
    actualStartDate: '开始日期',
    actualEndDate: '结束日期',
    actualTrainStartDate: '培训日期'
  }
};